import { useQuery } from "@tanstack/react-query"
import { getOnboardingReport } from "./OnboardingReportRepo"

export const useOnBoarding_Report=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['Mas_REPORT',param],
        queryFn:()=>getOnboardingReport(param),
        enabled:enable,
        retry:false,
    })
}
